import $ from 'jquery';
import 'select2';
import 'jquery.easing';
import 'Inputmask';
import 'jquery-validation';

const $payments = $('.payments-cap-container');
const $paymentCapCountry = $('.payment-country-list .country-body a');
const $paymentSelect = $('.payment-country-select');
const $mapContainer = $('#regions-map');
var continentArr = '';
var countryArr = [];
var data;
var chart;
var sortOrder = 0;

// Iterate through payment blocks on page
$payments.each((i, el) => {
    // add class to body to restrict styles to this page only
    $('body').attr('class', 'payments-cap-main')
    // create continent array from string
    const regex = /'/gi;
    continentArr = eval($payments.attr('data-continents').replace(regex, '"'));
    // Prepare the country list
    setCountryList();
    // Load the Visualization API and the piechart package.
    google.charts.load('current', {
        'packages': ['geochart'], 'mapsApiKey': $payments.attr('data-maps-api-key')
    });
    // Set a callback to run when the Google Visualization API is loaded.
    google.charts.setOnLoadCallback(drawRegionMap);
});

// Iterate through continent header to replace continent names in list
$('.payment-country-list .continent-header').each((i, elCh) => {
    var headContinent = $(elCh).find('a span');
    var linkText = headContinent.text();

    if (continentArr.indexOf(linkText)) {
        if (continentArr[0].hasOwnProperty(linkText)) {
            headContinent.text(continentArr[0][linkText]);
        }
    }
});

//select2 config
$paymentSelect.select2({
    placeholder: $paymentSelect.attr('data-placeholder'),
    data: countryArr,
    matcher: matchCustom,
    sorter: sortResults,
    allowClear: true,
});

// On country search select
$paymentSelect.on('change', function (e) {
    const countryCode = $(this).val();
    // show modal
    if (countryCode.length > 0)
        showModal(countryCode);
});

// select list icon class behaviour
$('.payment-country-list').on('hide.bs.collapse show.bs.collapse', e => {
    $(e.target).prev().toggleClass('active');
    $(e.target)
        .prev()
        .find("i:last-child")
        .toggleClass("fa-chevron-down fa-chevron-up");
});

// On country click
$paymentCapCountry.on('click', function () {
    const countryCode = $(this).data('country-code');
    // show modal
    if (countryCode.length > 0)
        showModal(countryCode);
});

// Prepare Country list array
function setCountryList() {
    var queryString = '';
    var objCountry = {};
    $paymentCapCountry.each((i, country) => {
        const $country = $(country);
        var specialSortVal = $country.attr('data-country-sort') ? $country.attr('data-country-sort') : -1;
        queryString = $country.attr('data-country-title') + ' - ' + $country.attr('data-currency-title') + ' - ' + $country.attr('data-currency-code');
        objCountry = { id: $country.attr('data-country-code'), text: queryString, sort: 0, specialSort: specialSortVal };
        countryArr.push(objCountry);
    });
    // have empty option with default text to show
    countryArr.unshift({ id: '', text: $paymentSelect.attr('data-placeholder') });
}

// Match criterion for select2 search, loops throught data arr for each search term
function matchCustom(params, data) {
    // If there are no search terms, return all of the data
    if ($.trim(params.term) === '') {
        sortOrder = 0;
        return data;
    }
    // Do not display the item if there is no 'text' property
    if (typeof data.text === 'undefined') {
        sortOrder = 0;
        return null;
    }
    var filteredChildren = [];
    // `params.term` should be the term that is used for searching; `data.text` is the text that is displayed for the data object
    // countryArr.length is items in country arr; 
    var curr = data.text.substr(data.text.lastIndexOf(' - ') + 3);
    sortOrder = sortOrder + 1;
    if (data.text.toUpperCase().indexOf(params.term.toUpperCase()) > -1) {
        // search match from begining of term
        if (data.text.toUpperCase().indexOf(params.term.toUpperCase()) == 0) {
            data.sort = sortOrder;
            filteredChildren.push(data);
        }
        // currency exact match with term
        else if (params.term.toUpperCase() == curr.toUpperCase()) {
            // for special data items to show on top
            if (data.specialSort >= 0) {
                data.sort = data.specialSort;
                filteredChildren.push(data);
            } else {
                data.sort = (sortOrder + countryArr.length);
                filteredChildren.push(data);
            }
        }
        // all other terms
        else if (data.text.toUpperCase().indexOf(params.term.toUpperCase()) > 0) {
            data.sort = (sortOrder + (countryArr.length * 2));
            filteredChildren.push(data);
        }

        if (filteredChildren.length) {
            var modifiedData = $.extend({}, data, true);
            // You can return modified objects from here
            return modifiedData;
        }
    }
    // Return `null` if the term should not be displayed
    return null;
}

// sort the select2 list results
function sortResults(results) {
    return results.sort(function (a, b) {
        if (a.sort > b.sort) {
            return 1;
        } else if (a.sort < b.sort) {
            return -1;
        } else {
            return 0;
        }
    });
}

// Modal related
function showModal(countryCode) {
    var $modalCurr = $('#modal-' + countryCode);
    var continentCode = $modalCurr.parents('.collapse').attr('aria-labelledby');
    // simulate the accordion click
    if ($('#' + continentCode + ' a[aria-expanded=true]').length == 0) {
        $('#' + $modalCurr.parents('.collapse').attr('aria-labelledby')).find('a').click();
    }
    // trigger modal
    $modalCurr.modal();
    // format Modal
    formatModalCaps(countryCode);
    // call to add currency code
    addCurrency(countryCode);
    // scroll to map region
    $('html, body').animate({
        scrollTop: $mapContainer.offset().top - 0
    }, 'slow');
}

// Modal format for 2 col
function formatModalCaps(countryCode) {
    var colsCard = $('#modal-' + countryCode).find('div[data-row=2nd] div[data-cap-col=1]');
    // for 2 or more columns of capability groups
    if (colsCard.length > 1) {
        colsCard.addClass('col-md-6');
        colsCard.children('.row').css('margin-right', '1px');
    }
}

// add currency code in modal
function addCurrency(countryCode) {
    var $paymentFooterLink = $('#modal-' + countryCode).find('.modal-footer a.payment-link');
    if ($paymentFooterLink.attr('data-currency-added') != 1) {
        $paymentFooterLink.html(($paymentFooterLink.html()).trim() + ' ' + $('#modal-' + countryCode).attr('data-currency-code'));
        $paymentFooterLink.attr('data-currency-added', 1);
    }
}

// Google geo charts for map draw
function drawRegionMap() {
    var countryColor = '#fd0';
    var countryText = '';
    var countryCode = '';
    var countryTitle = '';
    var resultArr = [];

    data = new google.visualization.DataTable();
    data.addColumn('string', 'Country');
    data.addColumn('string', 'Title');

    if (countryArr.length) {
        for (var index in countryArr) {
            countryText = countryArr[index].text;
            countryCode = countryArr[index].id;
            countryTitle = countryText.slice(0, countryText.indexOf(' - ')).trim();
            resultArr.push([countryCode, countryTitle]);
        }
    }

    data.addRows(
        resultArr
    );

    // Set chart options
    var options = {
        'title': 'Payment Capabilities, WUBS',
        'width': '100%',
        'height': 698,
        'defaultColor': countryColor,
        'domain': 'IN'
    };

    // Instantiate and draw our chart, passing in some options.
    chart = new google.visualization.GeoChart(document.getElementById('regions-map'));
    google.visualization.events.addListener(chart, 'select', selectHandler);
    console.log(' draw region map :-/ ');
    chart.draw(data, options);
}

// select handler geo charts click
function selectHandler() {
    if (typeof chart.getSelection()[0] != 'undefined') {
        var selectedItem = chart.getSelection()[0];
        var value = data.getValue(selectedItem.row, 0);
        if (value.length > 0)
            showModal(value);
    }
}
